<template>
    <div :class="['box', routeName === 'studyReport' ? 'study-box' : '']">
        <img
            v-show="showPlayBtn"
            class="play-btn"
            @click="handlePlayAudio"
            src="https://i.gsxcdn.com/2703671714_ossoln0y.png"
            alt=""
            srcset=""
        >
        <div id="book" ref="book" class="flipbook">
            <img
                v-for="(item, index) in picbookData"
                :key="index"
                class="img"
                :src="item.imageUrl"
                alt=""
                srcset=""
            >
        </div>
        <!-- 用户 -->
        <div class="user">
            <img :class="['head-box', userHeadClass]" :src="headImage" alt="">
            <canvas
                :class="['user-spine']"
            ></canvas>
        </div>
        <!-- 毛豆 -->
        <canvas :class="['md-spine']"></canvas>
    </div>
</template>

<script>
import {
    sendMessageApp,
    isWebEnv,
    isAndroid,
    logNative,
    loadSpine
} from '@/utils/utils';

const mdtalk = 'static/spine/picbook/mdtalk/mdtalk.json';
const usertalk = 'static/spine/picbook/usertalk/usertalk.json';

const MOCK = {
    // https://p.gsxcdn.com/feihua/idiom/20241023/2712054986_hjsapt6p.png
    // https://i.gsxcdn.com/feihua/20241022/Tiif_1729585299.png
    "headImage": 'https://p.gsxcdn.com/feihua/idiom/20241023/2712054986_hjsapt6p.png',
    "picbookData": [
        {
            "imageUrl": "https://i.gsxcdn.com/2703698065_z68adipl.png",
            "picbookAudioInfo": [
                {
                    "audioType": "maodou",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                },
                {
                    "audioType": "user",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                }
            ]
        },
        {
            "imageUrl": "https://i.gsxcdn.com/2703698065_z68adipl.png",
            "picbookAudioInfo": [
                {
                    "audioType": "maodou",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                },
                {
                    "audioType": "user",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                }
            ]
        },
        {
            "imageUrl": "https://i.gsxcdn.com/feihua/20231228/qOyC_1703743246.jpeg",
            "picbookAudioInfo": [
                {
                    "audioType": "maodou",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                },
                {
                    "audioType": "user",
                    "audioUrl": "https://i.gsxcdn.com/feihua/20241017/zRTm_1729147519.mp3"
                }
            ]
        },
    ]
};

export default {
    props: {
        pageData: {
            type: Array,
            default() {
                return MOCK;
            }
        },
        routeName: {
            type: String,
            default() {
                return 'picbook';
            }
        },
    },
    data() {
        return {
            mdloaded: false,
            userloaded: false,
            started: false,
            turnHasInit: false,

            picbookData: [],
            headImage: '',
            curPage: {},
            curPageIndex: 0,
            curAudio: {},
            curAudioIndex: 0,

            showPlayBtn: true,

            userSpine: null,
            mdSpine: null,
            userHeadClass: 'userdaiji',

            audioEl: null,
        };
    },
    watch: {
        mdloaded(val) {
            if (val && this.userloaded) {
                this.handleStart();
            }
        },
        userloaded(val) {
            if (val && this.mdloaded) {
                this.handleStart();
            }
        },
    },
    mounted() {
        this.registerFunc();
        this.initSpine();
    },
    beforeUnmount() {
        this.destroyTurnJs();
    },
    methods: {
        initializeTurnJs() {
            console.log('初始化翻页组件');
            this.$nextTick(() => {
                let width = '';
                let height = '';
                if (this.routeName === 'studyReport') {
                    width = '7.44rem';
                    height = '4.19rem';
                } else {
                    width = '100vw';
                    height = '100vh';
                }
                $(this.$refs.book).turn({
                    width,
                    height,
                    display: 'single',
                    disable: true,
                    // 禁用鼠标拖拽
                    disableMouse: true,
                    // 禁用触摸屏滑动翻页
                    swipe: false,
                    autoCenter: true,
                    gradients: true,
                    elevation: 100,
                    duration: 800
                });
                this.turnHasInit = true;
            });
        },
        destroyTurnJs() {
            $(this.$refs.book).turn('destroy');
        },
        // 注册 js 能力给端上调用
        registerFunc() {
            console.log('进入registerFunc方法');
            if (this.routeName !== 'studyReport') {
                /**
                 * 如果是学习报告加载的绘本组件就不需要单独加appDisplayState方法了，学习报告统一处理过了
                 */
                // 注册 js 能力 —— 前后台切换
                window.callbackMap.appDisplayState = state => {
                    console.log('appDisplayState', state);
                    if (!state) {
                        return;
                    }
                    // state '1'：页面进入前台
                    if (String(state) === '1') {
                        console.log('appDisplayState 进入前台');
                        window.callbackMap.handlePicbookH5(JSON.stringify({
                            type: 'resume'
                        }));
                    }
                    // state '2'：页面进入后台
                    else if (String(state)  === '2') {
                        console.log('appDisplayState 进入后台');
                        window.callbackMap.handlePicbookH5(JSON.stringify({
                            type: 'pause'
                        }));
                    }
                };
            }
            // 注册 js 能力 —— 客户端给动态绘本H5页传入绘本数据(或刷新绘本数据)
            window.callbackMap.setPicbookData = picbookDataStr => {
                console.log('setPicbookData', picbookDataStr);
                if (!picbookDataStr) {
                    return;
                }
                // 重置页面状态，页面已经恢复
                this.resetPage();
                // 解析客户端传入的数据
                const picbookDataObj = JSON.parse(picbookDataStr);
                console.log('setPicbookData回调数据', picbookDataObj);
                const {headImage, picbookData} = picbookDataObj;
                this.headImage = headImage;
                this.picbookData = picbookData;
                !this.turnHasInit && this.initializeTurnJs();
            };

            // 注册 js 能力 —— 操作(暂停/恢复)动态绘本H5页
            window.callbackMap.handlePicbookH5 = typeJsonStr => {
                console.log('handlePicbookH5', typeJsonStr);
                if (!typeJsonStr) {
                    return;
                }
                const typeJsonObj = JSON.parse(typeJsonStr);
                if (typeJsonObj.type === 'pause') {
                    console.log('暂停H5动态绘本');
                    // 如果正在播放语音，则暂停
                    this.audioEl && this.audioEl.pause();
                    this.handleSpine('', 'init');
                }
                else if (typeJsonObj.type === 'resume') {
                    console.log('恢复H5动态绘本看看this.isPlayingAudio', this.isPlayingAudio);
                    // 如果原来正在播放语音，则继续播放该语音
                    this.audioEl && this.audioEl.play();
                    this.handleSpine('', '');
                }
            };
        },
        // 开始
        handleStart() {
            if (this.started) {
                return;
            }
            this.started = true;
            // 如果是从学习报告过来的，自己调用下 js 能力 —— 客户端给动态绘本H5页传入绘本数据(或刷新绘本数据)
            if (this.routeName === 'studyReport' || isWebEnv()) {
                window.callbackMap.setPicbookData(JSON.stringify(this.pageData));
            } else {
                // 调用端能力-加载完成 loadFinish，通知客户端去调用 setPicbookData 方法
                setTimeout(() => {
                    sendMessageApp('loadFinish');
                }, 10);
            }
        },
        // 重置页面
        resetPage() {
            this.audioEl && this.audioEl.pause();
            this.curPageIndex = 0;
            this.curAudioIndex = 0;
            this.showPlayBtn = true;
            $(this.$refs.book) && $(this.$refs.book).turn('page', this.curPageIndex + 1);
            this.handleSpine('', 'init');
        },
        // 初始化spine
        initSpine() {
            const url = window.location.href;
            const routeName = this.routeName;
            const index = url.indexOf(routeName);
            const mdPath = `${url.slice(0, index)}${mdtalk}`;
            const userPath = `${url.slice(0, index)}${usertalk}`;
            loadSpine(
                mdPath,
                document.querySelector('.md-spine'),
                {
                    width: 200,
                    height: 250,
                    spineX: 100,
                    spineY: 130
                },
                res => {
                    console.log('res', res);
                    this.mdSpine = res;
                    this.mdSpine.setAnimation(0, 'animation1', true);
                    this.mdloaded = true;
                }
            );

            loadSpine(
                userPath,
                document.querySelector('.user-spine'),
                {
                    width: 200,
                    height: 150,
                    spineX: 100,
                    spineY: 80
                },
                res => {
                    console.log('res', res);
                    this.userSpine = res;
                    this.userSpine.setAnimation(0, 'animation1', true);
                    this.userloaded = true;
                }
            );
        },
        // 开始处理语音播放
        handlePlayAudio() {
            if (!this.started) {
                return;
            }
            if (this.showPlayBtn) {
                this.showPlayBtn = false;
                (this.routeName !== 'studyReport') && sendMessageApp('startPlay');
            }
            this.curPage = this.picbookData[this.curPageIndex];
            const {picbookAudioInfo} = this.curPage;
            this.curAudio = picbookAudioInfo[this.curAudioIndex];
            const {audioType, audioUrl} = this.curAudio;
            this.handleSpine(audioType);
            this.playAudio(audioUrl).then(() => {
                // 语音播放完成，回到呼吸态
                this.handleSpine(audioType, 'init');
                // 当前页数下的语音全部播放完成，播放下一页
                if (picbookAudioInfo.length === this.curAudioIndex + 1) {
                    // 所有页数都播放完成，回到初始状态
                    if (this.picbookData.length === this.curPageIndex + 1) {
                        console.log('所有页数都播放完成，回到初始状态');
                        this.resetPage();
                        return;
                    }
                    this.curPageIndex += 1;
                    this.curAudioIndex = 0;
                    $(this.$refs.book).turn('next');
                    console.log('当前页数下的语音全部播放完成，播放下一页this.curPageIndex=', this.curPageIndex);
                } else {
                    // 继续播放当前页数下的语音
                    this.curAudioIndex += 1;
                    console.log('继续播放当前页数下的语音this.curAudioIndex=', this.curAudioIndex);
                }
                this.handlePlayAudio();
            });
        },
        // 处理动效播放
        handleSpine(audioType, state) {
            const animation = state === 'init' ? 'animation1' : 'animation2';
            if (audioType === 'maodou') {
                this.mdSpine.setAnimation(0, animation, true);
            } else if (audioType === 'user') {
                this.userHeadClass = animation === 'animation1' ? 'userdaiji' : 'userspeak';
                this.userSpine.setAnimation(0, animation, true);
            } else {
                // 用于重置毛豆和用户的整个播放状态
                this.mdSpine.setAnimation(0, animation, true);
                this.userHeadClass = animation === 'animation1' ? 'userdaiji' : 'userspeak';
                this.userSpine.setAnimation(0, animation, true);
            }
        },
        // 播放语音
        playAudio(url) {
            console.log(' ------ playAudio ------', url);
            // 播放语音
            return new Promise(resolve => {
                if (!url) {
                    resolve();
                }
                if (!this.audioEl) {
                    const audio = new Audio();
                    audio.onabort = () => {
                        logNative(
                            JSON.stringify({
                                content: 'playAudio onabort',
                                audioUrl: url,
                            })
                        );
                        console.log(`playAudio onabort ${url}`);
                    };
                    audio.onwaiting = () => {
                        logNative(
                            JSON.stringify({
                                content: 'playAudio onwaiting',
                                audioUrl: url,
                            })
                        );
                        console.log(`playAudio onwaiting ${url}`);
                    };
                    this.audioEl = audio;
                }
                this.audioEl.src = url;
                this.audioEl.currentTime = 0;
                this.audioEl.load();
                this.audioEl.onended = () => {
                    console.log('playAudio onended', url);
                    resolve();
                };
                this.audioEl.onpause = () => {
                    console.log('playAudio onpause', url);
                };
                this.audioEl.onerror = error => {
                    logNative(
                        JSON.stringify({
                            content: 'playAudio onerror',
                            audioUrl: url,
                            error: this.audioEl.error?.message,
                        })
                    );
                    console.log('playAudio onerror', url);
                    console.log(this.audioEl.error?.message);
                    resolve(error);
                };
                this.audioEl.play();
            });
        },
    }
};
</script>

<style lang="scss" scoped>
@keyframes userdaiji {
    0% { transform: translateY(0); }
    50% { transform: translateY(.053rem); }
    100% { transform: translateY(0); }
}
.userdaiji {
    animation: userdaiji 1000ms ease-in-out infinite;
}

/* 定义旋转动画 */
@keyframes userspeak {
    0% {
        transform: rotate(0deg);
    }
    3.34% {
        transform: rotate(7deg); /* 167ms */
    }
    6.68% {
        transform: rotate(-7deg); /* 167ms */
    }
    26.68% {
        transform: rotate(-7deg); /* 1000ms 保持 -7° */
    }
    30.02% {
        transform: rotate(7deg); /* 167ms */
    }
    33.36% {
        transform: rotate(-7deg); /* 167ms */
    }
    53.36% {
        transform: rotate(-7deg); /* 1000ms 保持 -7° */
    }
    56.7% {
        transform: rotate(7deg); /* 167ms */
    }
    60.04% {
        transform: rotate(-7deg); /* 167ms */
    }
    80.04% {
        transform: rotate(-7deg); /* 1000ms 保持 -7° */
    }
    86.72% {
        transform: rotate(0deg); /* 334ms */
    }
    100% {
        transform: rotate(0deg); /* 667ms */
    }
}
.userspeak {
    animation: userspeak 5s cubic-bezier(.42, 0, .58, 1) infinite;
    transform-origin: center bottom; /* 旋转中心为底部中心 */
}

.box {
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    border-radius: .32rem;
    background: #fff;
    position: relative;

    .play-btn {
        z-index: 3;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.73rem;
        height: 2.73rem;
    }

    .flipbook {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;

        .img {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }

    .user {
        width: 5.33rem;
        position: absolute;
        z-index: 2;
        bottom: -.78rem;
        left: 1.09rem;
        display: flex;
        justify-content: center;

        .head-box {
            width: 5.74rem;
            height: 5.74rem;
            position: absolute;
            bottom: 2.48rem;
            z-index: 2;
        }

        .user-spine {
            z-index: 1;
            position: absolute;
            bottom: 0;
            width: 4.264rem;
            height: 3.2rem;
        }
    }

    .md-spine {
        width: 4.264rem;
        height: 5.336rem;
        position: absolute;
        z-index: 2;
        bottom: -.7rem;
        right: 1.2rem;
    }
}

.study-box {
    width: 7.44rem;
    height: 4.19rem;
    top: 1.03rem;
    border-radius: .21rem;

    .play-btn {
        width: 1.39rem;
        height: 1.39rem;
    }

    .user {
        width: 1.07985rem;
        bottom: -.3795rem;
        left: .859rem;

        .head-box {
            width: 2.6979rem;
            height: 2.6979rem;
            bottom: 1.1661rem;
        }

        .user-spine {
            bottom: 0;
            width: 2.0033rem;
            height: 1.5040rem;
        }
    }

    .md-spine {
        width: 2.001rem;
        height: 2.507rem;
        bottom: -.3689rem;
        right: .5635rem;
    }
}
</style>
